import React from 'react'

function Footer() {
  return (
      <footer className="footer">
        <span className="copyright">Item data provided with 💓 by <a href="https://enc.dofusdu.de/q/swagger/">Dofus API</a> by stelzo.</span>
        <br />
        <span className="credits">All images belong to <a href="http://www.ankama.com">Ankama©</a></span>
      </footer>
  )
}

export default Footer
